import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Swiper } from "swiper/swiper";
import SwiperCore from "swiper";
import {Pagination,A11y} from "swiper/modules"
declare var document: any;

@Component({
  standalone: false,
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  carouselImages = [
    { name: '', url: './assets/carousel/1.png' },
    { name: '', url: './assets/carousel/2.png' },
    { name: '', url: './assets/carousel/3.png' },
    { name: '', url: './assets/carousel/4.png' }
  ];

  ind: any;
  arrows: boolean;

  constructor(private route: Router) {
    SwiperCore.use([Pagination, A11y]);
   }

  ngOnInit() {
    this.width();
    this.isEngagement();
  }

  isEngagement() {
    const aux = sessionStorage.getItem('getParams');
    const getParams = JSON.parse(aux);
    if (getParams) {
      sessionStorage.setItem('auxParam', aux);
    }
  }

  /**
   * lleva a la URL traida por parametro
   * @param route: String
   */
  navigateToUrl(route) {
    debugger
    sessionStorage.setItem('_hc', '1');
    this.route.navigateByUrl(route);
  }

  width() {
    this.arrows = window.innerWidth > 902;
  }

  onResize(e) {
    this.arrows = e.currentTarget.innerWidth > 902;
  }

  disableDragging(e) {
    e.preventDefault();
  }
  slideNext() {
    debugger
    const swiperEl = document.getElementById('cardsswiper') as any;
    swiperEl.swiper.slideNext(100);
  }
  slidePrev() {
    const swiperEl = document.getElementById('cardsswiper') as any;
    swiperEl.swiper.slidePrev(100);
  }
}
